// ResponsiveLivraisons.jsx → src/gestion-vente/
import React from "react";
import GestionLivraisons from "./GestionLivraisons";
import LivraisonsMobile from "../mobile/ventes/LivraisonsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveLivraisons(props) {
  return useIsMobile() ? <LivraisonsMobile {...props} /> : <GestionLivraisons {...props} />;
}
